import React from 'react'
import { Typography, Chip, Button, CircularProgress } from '@material-ui/core'
import { DECISION_STATUS_LABELS, DECISION_STATUS_COLORS, DECISION_TYPE_LABELS } from '../../constants/contextEnums'

const DecisionsTab = ({ items, loading, onEdit, onSupersede }) => {
  const [expandedRationale, setExpandedRationale] = React.useState({})

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No decisions recorded.</Typography>
  }

  const handleSupersede = (decision, e) => {
    e.stopPropagation()
    onSupersede(decision)
  }

  return items.map((decision) => {
    const isRationaleOpen = !!expandedRationale[decision._id]
    return (
      <div
        key={decision._id}
        style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
        onClick={() => onEdit('decision', decision)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          <Chip
            label={DECISION_STATUS_LABELS[decision.status] || decision.status}
            size="small"
            style={{ height: 20, fontSize: 11, backgroundColor: DECISION_STATUS_COLORS[decision.status] || '#9e9e9e', color: '#fff' }}
          />
          <Chip label={DECISION_TYPE_LABELS[decision.decision_type] || decision.decision_type} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
        </div>
        <div style={{ fontSize: 13, fontWeight: 500 }}>{decision.title}</div>
        {decision.decision && <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{decision.decision}</div>}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
          {decision.affects_price && <Chip label="Affects Price" size="small" style={{ height: 18, fontSize: 10, backgroundColor: 'var(--warn-tint, #fff3e0)', color: 'var(--warn)' }} />}
          {decision.affects_output && <Chip label="Affects Output" size="small" style={{ height: 18, fontSize: 10, backgroundColor: 'var(--info-tint, #e3f2fd)', color: 'var(--info)' }} />}
        </div>
        {decision.rationale && (
          <div style={{ marginTop: 4 }}>
            <a
              style={{ fontSize: 11, color: 'var(--brand, #1976d2)', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); setExpandedRationale(prev => ({ ...prev, [decision._id]: !prev[decision._id] })) }}
            >
              {isRationaleOpen ? 'Hide rationale' : 'Show rationale'}
            </a>
            {isRationaleOpen && <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 4, paddingLeft: 8, borderLeft: '2px solid var(--line, #e0e0e0)' }}>{decision.rationale}</div>}
          </div>
        )}
        {decision.status === 'active' && (
          <Button
            size="small"
            style={{ textTransform: 'none', fontSize: 11, marginTop: 4, color: 'var(--ink-4, #9e9e9e)' }}
            onClick={(e) => handleSupersede(decision, e)}
          >
            Supersede
          </Button>
        )}
      </div>
    )
  })
}

export default DecisionsTab
